import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { DialogService } from "primeng/dynamicdialog";
import { UserService } from "../../../../shared";
import { ReportService } from "../../../Report/report.service";
import { ReportFileTypeDialogComponent } from "../../shared/report-file-type-dialog/report-file-type-dialog.component";
import { DataService_Student_Class_Attendance } from "../shared/data.service";
import { StudentEditClassAttendanceComponent } from "./student-edit-class-attendance/student-edit-class-attendance.component";
import * as moment from "moment";

@Component({
	selector: "caass-class-attendance-table",
	templateUrl: "./class-attendance-table.component.html",
	styleUrls: ["./class-attendance-table.component.css"],
})
export class ClassAttendanceTableComponent implements OnInit {
	constructor(
		private classAttendanceService: DataService_Student_Class_Attendance,
		private dialogService: DialogService,
		private userService: UserService,
		private reportService: ReportService
	) {}

	ngOnInit(): void {
		this.user = this.userService.getCurrentUser();

		//Error handling

		//Load data
		this.loadClassAttendance();
	}

	ngOnChanges() {
		//Error handling

		//Load data
		this.onRowUnselect(null);
		this.loadClassAttendance();
	}

	////////////////////////////////////////////
	// Data
	////////////////////////////////////////////

	@Input() StartDate: any;
	@Input() EndDate: any;
	@Input() SelectedPerson: any;
	@Output() RefreshStats: EventEmitter<any> = new EventEmitter();
	@Output() EntrySelected: EventEmitter<any> = new EventEmitter();

	isProcessing: any;

	///////////////
	// Built-In
	///////////////

	user: any;
	pagerows: any = 10;
	pagefirst: any = 0;
	loading: any = false;
	errorMessage: any = "";

	///////////////

	///////////////
	// Custom
	///////////////

	//Main
	SelectedClassAttendance: any;
	lstClassAttendance: any = [];

	//Filter lists
	lstSection: any = [];
	lstClassAttendanceStatusDesc: any = [];
	lstClassAttendanceEntryTypeDesc: any = [];
	lstExcuse: any = [];

	//Cols
	cols: any = [
		//INSERT CUSTOM COLUMNS HERE
		{ field: "Section", header: "Section" },
		{ field: "EntryDateDesc", header: "Date/Time" },
		{ field: "ClassAttendanceStatusDesc", header: "Status" },
		{ field: "ClassAttendanceEntryTypeDesc", header: "Entry Method" },
		{ field: "Excuse", header: "Excuse" },
	];

	///////////////

	////////////////////////////////////////////

	////////////////////////////////////////////
	// Load Data
	////////////////////////////////////////////

	loadClassAttendance() {
		this.errorMessage = "";
		this.onRowUnselect(null);

		this.loading = true;

		if (this.SelectedPerson == undefined) {
			this.loading = false;
			return;
		}

		var fsDate = moment(this.StartDate).format("MM/DD/YYYY");
		var feDate = moment(this.EndDate).format("MM/DD/YYYY");

		if (String(fsDate).toLowerCase().indexOf("invalid") != -1 || String(feDate).toLowerCase().indexOf("invalid") != -1) {
			this.loading = false;
			return;
		}

		var result = this.classAttendanceService.ClassAttendanceTableInfoGetList(this.SelectedPerson.PersonID, fsDate, feDate);
		result.subscribe(
			(response) => {
				this.lstClassAttendance = response;

				for (var i = 0; i < this.lstClassAttendance.length; i++) {
					var next = this.lstClassAttendance[i];

					next.EntryDT = new Date(moment(new Date(next.EntryDate)).format("MM/DD/YYYY") + " " + moment(new Date(next.EntryTime)).format("HH:mm:ss"));
					next.EntryDateDesc = moment(new Date(next.EntryDate)).format("MM/DD/YYYY") + " " + moment(new Date(next.EntryTime)).format("h:mm a");
				}

				//Load Data Filter Lists
				this.lstSection = Array.from(new Set(this.lstClassAttendance.map((item: any) => item.Section))).sort();
				this.lstClassAttendanceStatusDesc = Array.from(new Set(this.lstClassAttendance.map((item: any) => item.ClassAttendanceStatusDesc))).sort();
				this.lstClassAttendanceEntryTypeDesc = Array.from(
					new Set(this.lstClassAttendance.map((item: any) => item.ClassAttendanceEntryTypeDesc))
				).sort();
				this.lstExcuse = Array.from(new Set(this.lstClassAttendance.map((item: any) => item.Excuse))).sort();

				this.loading = false;
			},
			(error) => {}
		);
	}

	////////////////////////////////////////////

	////////////////////////////////////////////
	// Buttons
	////////////////////////////////////////////

	onRefresh() {
		this.errorMessage = "";

		this.loadClassAttendance();
	}

	//Custom Button Methods
	onEditClassAttendance() {
		this.errorMessage = "";

		if (this.SelectedClassAttendance == undefined) {
			this.errorMessage = "Select a class attendance record to edit";
			return;
		}

		var ref = this.dialogService.open(StudentEditClassAttendanceComponent, {
			header: "Edit Class Attendance",
			width: "fit-content",
			data: {
				//INSERT Custom Data here
				user: this.user,
				SelectedPerson: this.SelectedPerson,
				SelectedEntry: this.SelectedClassAttendance,
			},
		});
		ref.onClose.subscribe((response) => {
			if (response == 1) {
				this.onRowUnselect(null);
				this.loadClassAttendance();

				this.RefreshStats.emit(1);
			}
		});
	}

	onPrintClassAttendance() {
		this.errorMessage = "";

		//Error handling
		if (this.SelectedPerson == undefined) {
			this.errorMessage = "Select a person to print attendance records";
		}

		var ref = this.dialogService.open(ReportFileTypeDialogComponent, {
			header: "Report File Type",
			width: "fit-content",
			data: {},
		});
		ref.onClose.subscribe((response) => {
			if (response > 0) {
				this.FinishPrint(response);
			}
		});
	}

	FinishPrint(OutputType) {
		//Call SP

		var component = this;
		this.isProcessing = true;

		this.errorMessage = "";

		var strParam = "";

		//
		//Params from filtering:
		//

		var Semester = "%%";
		var SectionNo = "%%";
		var CourseNo = "%%";

		// var SFilter = <HTMLElement> document.getElementById("MTARouteStationDesc").children[0].children[0].children[0];

		// if(RSFilter.innerText != "Any"){
		//   RouteStation = RSFilter.innerText;
		// }

		//Parameter 1: PersonID
		strParam += this.SelectedPerson.PersonID + "|PersonID";

		//Parameter 2: Semester
		strParam += "," + Semester + "|Semester";

		//Parameter 3: SectionNo
		strParam += "," + SectionNo + "|SectionNo";

		//Parameter 4: CourseNo
		strParam += "," + CourseNo + "|CourseNo";

		//Parameter 5: Start Date
		strParam += "," + moment(this.StartDate).format("MM/DD/YYYY") + "|StartDate";

		//Parameter 6: End Date
		strParam += "," + moment(this.EndDate).format("MM/DD/YYYY") + "|EndDate";

		var reportID: any = 253;

		//Add type selector
		var result = this.reportService.Print(reportID, strParam, this.SelectedPerson.SchoolID, OutputType);

		result.subscribe(
			(response: any) => {
				component.isProcessing = false;
				window.open(response);
			},
			(error) => {
				component.errorMessage = error;
				component.isProcessing = false;
			}
		);
	}

	////////////////////////////////////////////

	////////////////////////////////////////////
	// Events
	////////////////////////////////////////////
	onHandleFilter(val) {}
	onHandleSort(val) {}
	onRowSelect(val) {
		this.errorMessage = "";

		this.SelectedClassAttendance = val.data;

		this.EntrySelected.emit(this.SelectedClassAttendance);
	}
	onRowUnselect(val) {
		this.errorMessage = "";

		this.SelectedClassAttendance = null;
		this.EntrySelected.emit(this.SelectedClassAttendance);
	}
	onRowDblClick(ClassAttendance) {
		this.SelectedClassAttendance = ClassAttendance;

		this.EntrySelected.emit(this.SelectedClassAttendance);

		this.onEditClassAttendance();
	}
	////////////////////////////////////////////
}
